import React from "react";
import { WhatsAppIcon } from "./CustomSVG";
import { Phone, Mail } from "lucide-react";

interface ContactInfoProps {
  type: "email" | "phone" | "whatsapp" | "website"; // expand later
  value: string | undefined;
  icon?: React.ReactNode; // Pass any icon component
  label?: string;
  className?: string;
}

const ContactInfo: React.FC<ContactInfoProps> = ({
  type,
  value,
  icon,
  label,
  className = "",
}) => {
  // Determine href based on type
  let href = "#";
  switch (type) {
    case "email":
      href = `mailto:${value}`;
      break;
    case "phone":
      href = `tel:${value}`;
      break;
    case "whatsapp":
      // WhatsApp link for chat
      const phone = value?.replace(/\D/g, ""); // remove non-digits
      href = `https://wa.me/${phone}`;
      break;
    case "website":
      href = value?.startsWith("http") ? value : `https://${value}`;
      break;
    default:
      href = "#";
  }

  return (
    <span className="flex items-center gap-1 text-xs sm:text-sm text-gray-600">
      {label ? (
        label
      ) : type === "whatsapp" ? (
        <WhatsAppIcon />
      ) : icon ? (
        icon
      ) : type === "phone" ? (
        <Phone size={14} />
      ) : (
        <Mail size={14} />
      )}
      <a
        href={href}
        className={`text-gray-800 hover:text-blue-600 transition-colors duration-300 truncate ${className}`}
        target={
          type === "website" || type === "whatsapp" ? "_blank" : undefined
        }
        rel={
          type === "website" || type === "whatsapp"
            ? "noopener noreferrer"
            : undefined
        }
      >
        <span className="truncate">{value}</span>
      </a>
    </span>
  );
};

export default ContactInfo;
